module.exports = __webpack_public_path__ + "img/edit-icon.00d7ec1b.svg";